
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/reviews",
      function () {
        return require("private-next-pages/signature/reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/reviews"])
      });
    }
  